module.exports = __webpack_public_path__ + "static/media/Pixel5.png?v=67efef0b";